/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CalendarConnectionDestroyPathParams,
	CalendarConnectionDestroyResponse,
} from '../types/CalendarConnectionDestroy'

/**
 * DELETE /calendar-integrations/connections/:id
 * @see backend/nexus/modules/CalendarIntegrations/Http/Controllers/CalendarConnectionController.php CalendarConnectionController::destroy
 */
export async function calendarConnectionDestroy(
	id: CalendarConnectionDestroyPathParams['id'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CalendarConnectionDestroyResponse>> {
	return axiosInstance.delete(`/calendar-integrations/connections/${id}`, config)
}
